module.exports = "/public/webpack/img/icon_help_feedback_24c36497ac555c3fc92628d03d0451cc54.png";